/**
 * clearSession
 *
 * Wipes ALL app-related data from localStorage (token, OTP scratch values,
 * any future keys) and then redirects to /login.
 *
 * Call this from auto-logout, manual logout, or 401 interceptors.
 */

// Keys that must be removed on logout
const SESSION_KEYS = [
  'token',
  'reg_otp',
  'reg_otp_email',
  // add more keys here as needed
];

export const clearSession = () => {
  // Remove known session keys
  SESSION_KEYS.forEach(key => localStorage.removeItem(key));

  // Belt-and-suspenders: clear entire localStorage in case other keys were added
  // Comment this out if you need to preserve non-auth data (e.g., theme preference)
  localStorage.clear();
  sessionStorage.clear();
};

export const isLoggedIn = () => !!localStorage.getItem('token');
